enum ELayoutItemTypes {
	SIDEBAR_ITEM = 'LAYOUT_ITEM.SIDEBAR_ITEM',
	OBJECT_EXPLORER_ITEM = 'OBJECT_EXPLORER.MOVE',
	SECTION = 'LAYOUT_ITEM.SECTION',
	COLUMN = 'LAYOUT_ITEM.COLUMN',
	COMPONENT = 'LAYOUT_ITEM.COMPONENT'
}

export { ELayoutItemTypes };
